module.exports = __webpack_public_path__ + "static/img/liuyanlogo.cb3730d.png";


//////////////////
// WEBPACK FOOTER
// ./static/liuyanlogo.png
// module id = YsIB
// module chunks = 1